import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './ui/layout/Layout';
import Page404 from './ui/screens/Page404';
import SignIn from './ui/screens/SignIn';
import { defaultTheme } from './ui/styles/defaultTheme';
import { useEffect } from 'react';
import { useAuthCore } from './core/modules/auth';
import { useMeCore } from './core/modules/me';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { useCompanyCore } from './core/modules/company';

function App() {
  const { token } = useAuthCore();
  const { getMeUser } = useMeCore();
  const { setCompanyId, getCompanies, companies } = useCompanyCore();

  useEffect(() => {
    if (token) {
      getMeUser((response) => {
        if (response.company_id) {
          setCompanyId(response.company_id);
        }
      });
    }
  }, [token, getMeUser, setCompanyId]);

  // Cargar empresas globalmente al iniciar la app si la lista está vacía
  useEffect(() => {
    if (token && (!companies || companies.length === 0)) {
      getCompanies({});
    }
  }, [token, companies, getCompanies]);

  return (
    <CacheProvider
      value={createCache({
        key: 'muiltr',
        prepend: true,
        stylisPlugins: [],
        insertionPoint: document.getElementById('emotion-insertion-point')!,
      })}
    >
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={defaultTheme}>
          <BrowserRouter>
            <Routes>
              <Route index element={<SignIn />} />
              <Route path="/sign-in" element={<SignIn />} />
              <Route path="/dashboard/*" element={<Layout />} />
              <Route path="*" element={<Page404 />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </StyledEngineProvider>
    </CacheProvider>
  );
}

export default App;
